import { render, staticRenderFns } from "./survey-popup.vue?vue&type=template&id=5be7e8e4&scoped=true&"
import script from "./survey-popup.vue?vue&type=script&lang=js&"
export * from "./survey-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7e8e4",
  null
  
)

export default component.exports